<template>
  <div class="row">
    <div class="col-sm-6">
      <div class="panel-default panel">
        <div class="panel-body">
          <form action="#">
            <loader-box v-if="loading"/>
            <div class="form-group">
              <label for="file">Fichier excel CSV</label>
              <input type="file" name="file" id="file" class="form-control" accept=".csv, .CSV" @change="onFileChange">
            </div>
            <button id="load-file-button" class="app-button-inverted">Charger fichier <i class="fa fa-file"></i>
            </button>
          </form>
          <form action="#" @submit.prevent="submitSms" v-if="recipients.length">
            <div class="form-group">
              <label for="to" class="control-label">Destinataires</label>
              <textarea id="to" class="form-control" style="min-height: 400px;" :value="recipients.join(', ')" disabled></textarea>
            </div>
            <div class="form-group">
              <label for="message" class="control-label">Message</label>
              <textarea style="min-height: 300px" name="message" id="message" class="form-control" v-model="sms.message"></textarea>
            </div>
            <button class="app-button btn-block" type="submit">Envoyer <i class="fa fa-send-o"></i></button>
          </form>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="panel panel-default">
        <ul class="list-group">
          <li class="list-group-item">1. Choisir la colonne contenant les numéros</li>
        </ul>
        <table class="table table-hover table-striped table-bordered">
          <thead>
          <tr>
            <th v-for="(row, index) in dataMatrix[0]" :key="'head' + index" style="text-align: center;">
              <a style="padding: 20px" href="#" @click.prevent="selectColumn(index)">{{ index }}</a>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(line, index) in dataMatrix" :key="'row' + index">
            <td v-for="(item, index) in line" :key="'col' + index">{{ item }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import Papa from 'papaparse'
  import LoaderBox from '../Loader/LoaderBox'
  import appAxios from '../../app-axios'
  import Swal from 'sweetalert2'

  export default {
    props: {
      url: {type: String, required: true}
    },
    components: {LoaderBox},
    data () {
      return {
        column: 0,
        loading: false,
        file: null,
        $fileElement: null,
        dataMatrix: [],
        sms: {
          to: [],
          message: ''
        }
      }
    },
    computed:{
      recipients () {
        return this.dataMatrix.map(record => record[this.column])
      }
    },
    methods: {
      selectColumn (column) {
        this.column = column
      },
      onFileChange (e) {
        let files = e.target.files
        if (!files.length) {
          return
        }
        let file = files[0]
        this.loading = true
        Papa.parse(file, {
          step: (results, parser) => {
            this.dataMatrix.push(...results.data)
            // console.log("Row data:", results.data);
            console.log("Row errors:", results.errors);
          },
          complete: (results, file) => {
            this.loading = false
            console.log("Parsing complete:", results, file);
          },
          error () {
            console.log('something went wrong', arguments)
          }
        })
      },
      submitSms () {
        this.loading = true
        this.sms.to = this.recipients
        console.log({sms: this.sms})
        debugger

        appAxios.post(this.url, this.sms)
          .then(apiResponse => {
            Swal({
              type: 'success',
              title: apiResponse.getMessage(),
              timer: 3000,
              showConfirmButton: false,
              onClose () {
                window.reload()
              }
            })
          })
          .catch(apiResponse => {
            Swal({
              type: 'error',
              title: apiResponse.getMessage(),
              timer: 3000,
              showConfirmButton: false,
            })
          })
          .then(_ => this.loading = false)
      }
    },
    mounted () {
      this.$fileElement = this.$el.querySelector('#file')
      this.$fileElement.addEventListener('change', (e) => {
        this.onFileChange(e.target.files[0])
      })
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/component/Sms/SmsFromFile.vue